var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('HeroHome'),_c('services'),_c('aboutWeb'),_c('benefits'),_c('counterJSK'),_c('featured'),_c('footerJSK')],1)}
var staticRenderFns = []

export { render, staticRenderFns }